import React from "react";
import { useNavigate } from "react-router-dom";

const BackButton = () => {
  const navigate = useNavigate();

  return (
    <button className="back-btn" onClick={() => navigate("/#projects")}>
      Back to Projects
    </button>
  );
};

export default BackButton;
